import { Box } from '@mui/material'
import React from 'react'
const RenderList = (passvalue) => {
    const data = passvalue.data.data
    const names = ['Date', 'Type', 'Customer name', 'Email ', 'Description', 'Gross amount (NGN)', 'Reward given (NGN)', 'Fee (NGN)', 'Status']
    const values = [data.date, data?.transaction, data?.username, data?.email, data?.description, data?.total, data?.reward_earned, data?.fee, data?.status]
    return names.map((name, i) => {
        return (
            <div key={i} className='py-3 w-[90%] mx-auto flex items-center border-b-[1px]'>
                {/* {t('credit.credit_details')} */}
                <div className='w-[47%] text-[#657585] font-[16px] font-[400]'>
                    {name}
                </div>
                <div className='w-[47%] text-[#05213D] font-[16px] font-[400]'>
                    {
                        name === 'Status' ?
                            (values[i] === 'completed' ?
                                <div className='border border-success text-success rounded-md text-center text- w-[100px] py-2' style={{ background: 'rgba(68, 196, 161, 0.12) ' }}>
                                    {values[i]}
                                </div>
                                :
                                <div className='border border-danger text-danger rounded-md text-center text- w-[100px] py-2'>
                                    {values[i]}
                                </div>
                            )
                            :
                            (values[i])
                    }
                </div>
            </div>
        )
    })
}

function RedemptionDetails(data) {
    return (
        <Box className='!flex !flex-col justify-between'>
            <RenderList data={data} />
        </Box>
    )
}

export default RedemptionDetails